module.exports = __webpack_public_path__ + "static/media/world.7ccec61b.webp";